// AI Generated File
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { PageService } from '@client/app/services/entities/page/page.service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { LoadingService } from '@monsido/angular-shared-components';

@Component({
    selector: 'page-link-dropdown-all',
    standalone: false,
    template: `
        <div class="page-link-dropdown-multiple-selection-button-container">
            <div class="btn-group mr-1" *ngIf="selected.length" ngbDropdown>
                <button type="button"
                        class="btn btn-border-radius btn-marine-blue"
                        ngbDropdownToggle>
                    {{ 'Action [[selectedLength]] selected' | translate:'': {selectedLength: selected.length} }}
                </button>
                <button type="button"
                        class="btn btn-border-radius btn-marine-blue dropdown-toggle"
                        aria-haspopup="true"
                        aria-expanded="false"
                        ngbDropdownToggle>
                    <span class="caret"></span>
                    <span class="sr-only">Toggle Dropdown</span>
                </button>
                <ul class="dropdown-menu" ngbDropdownMenu>
                    <li *ngIf="status !== 'fixed'" class="cursor-pointer">
                        <a (click)="update('fixed')" role="button">
                        <span class="fas fa-check" aria-hidden="true"></span>
                        <span translate>Mark as fixed</span>
                        </a>
                    </li>
                    <li *ngIf="status !== 'ignored'" class="cursor-pointer">
                        <a (click)="update('ignored')" role="button">
                        <span class="fas fa-eye-slash" aria-hidden="true"></span>
                        <span translate>Ignore</span>
                        </a>
                    </li>
                    <li *ngIf="status !== 'dead'" class="cursor-pointer">
                        <a (click)="update('dead')" *ngIf="status === 'ignored' || status === 'hidden'" role="button">
                        <span class="fas fa-eye" aria-hidden="true"></span>
                        <span translate>Unignore</span>
                        </a>
                    </li>
                    <li *ngIf="status === 'fixed'" class="cursor-pointer">
                        <a (click)="update('dead')" role="button">
                        <span class="fas fa-times" aria-hidden="true"></span>
                        <span translate>Mark as not fixed</span>
                        </a>
                    </li>
                </ul>
            </div>

            <button type="button"
                    (click)="clearSelected()"
                    class="btn btn-border-radius btn-secondary clear-section-button-size"
                    *ngIf="selected.length"
                    translate>Clear selection</button>
        </div>
    `,
})
export class PageLinkDropdownAllComponent {
    @Input() selected: any[] = [];
    @Input() status?: string;
    @Input() pageId?: any;

    @Output() selectedChange = new EventEmitter<any[]>();
    @Output() callback = new EventEmitter();

    dialog: any;

    constructor (
        private loadingService: LoadingService,
        private linksRepoService: LinksRepoService,
        private pageService: PageService,
        private translateService: TranslateService,
    ) {}

    update (status: string) {
        const loadingTexts = {
            fixed: this.translateService.getString('Marking broken link as fixed'),
            ignored: this.translateService.getString('Ignoring broken link'),
            dead: this.translateService.getString('Reverting state'),
        };
        let chain = Promise.resolve();
        this.dialog = this.loadingService.service(this.translateService.getString('Please wait') + ' - ' + loadingTexts[status]);
        this.selected.forEach((value) => {
            if (this.pageId) {
                chain = chain.then(() => {
                    return this.patchPage(value, status).then(() => {});
                }).catch(() => {});
            } else {
                chain = chain.then(() => {
                    return this.patch(value, status).then(() => {});
                }).catch(() => {});
            }
        });

        chain
            .then(() => {
                this.dialog.close();
                this.callback.emit();
            })
            .catch(() => {})
            .finally(() => {
                this.dialog.close();
            });
    }

    clearSelected () {
        this.selected = [];
        this.selectedChange.emit(this.selected);
    }

    patch (link: any, status: string) {
        const params: any = {};
        params.status = status;
        params.id = link.id;
        return this.linksRepoService.update(params);
    }

    patchPage (link: any, status: string) {
        const params = {
            status: status,
        };

        return this.pageService.updateLink(this.pageId, link.id, params);
    }
}
